import { render, staticRenderFns } from "./ProfileCore.vue?vue&type=template&id=05665c95&"
import script from "./ProfileCore.vue?vue&type=script&lang=js&"
export * from "./ProfileCore.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports